import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { AppInformationService, AuthService, GenesisUnitOfWork, SessionInformationService } from 'app/core/core.module';
import { PurchaseOrderPickUp } from 'app/core/model/purchase-order-pick-up';
import { DxDataGridComponent } from 'devextreme-angular';
import { confirm } from 'devextreme/ui/dialog';
import { BsModalService } from 'ngx-bootstrap/modal';
import { VendorPickupDialogComponent } from '../vendor-pickup-dialog/vendor-pickup-dialog.component';
import { Router } from '@angular/router';

@Component({
    selector: 'app-vendor-search',
    templateUrl: './vendor-pickup-overview.component.html',
    styleUrls: ['./vendor-pickup-overview.component.scss'],
    standalone: false
})
export class VendorPickupOverviewComponent implements OnInit {
    uow = inject(GenesisUnitOfWork);
    auth = inject(AuthService);
    appInfo = inject(AppInformationService);
    modalService = inject(BsModalService);
    router = inject(Router);
    sessionInformationService = inject(SessionInformationService);

    pickups: any[];
    showCompleted: boolean = false;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

    async ngOnInit() {
        this.showCompleted = this.sessionInformationService.getItem('vendor-pickup-filter') ?? false;
        await this.getData();
    }

    async getData() {
        const pickups = await this.uow.getVendorPickUpInfos(this.showCompleted);
        this.initializeData(pickups);
        this.pickups = pickups;
        this.sessionInformationService.setItem('vendor-pickup-filter', this.showCompleted);
    }
    initializeData(pickups: any[]) {
        this.setLinesHtml(pickups);
    }

    setLinesHtml(pickups: any[]) {
        pickups.forEach((pickup) => {
            let linesHtml = '<table class="lines-table"><thead><tr><th>PO#</th><th>Mfg Part #</th><th>Quantity</th></tr></thead><tbody>';
            pickup.lines.forEach((line) => {
                linesHtml = `${linesHtml}<tr>`;
                linesHtml = `${linesHtml}<tr>`;
                linesHtml = `${linesHtml}<td>${line.completed ? '<s> ' : ''}${line.purchaseOrderLine.purchaseOrder.pONumber}</td>`;
                linesHtml = `${linesHtml}<td>${line.completed ? '<s> ' : ''}${line.mfgPartNumber}</td>`;
                linesHtml = `${linesHtml}<td>${line.completed ? '<s> ' : ''}${line.quantity}</td>`;
                linesHtml = `${linesHtml}</tr>`;
            });
            linesHtml += '</tbody></table>';
            pickup.linesHtml = linesHtml;
        });
    }

    async openPurchaseOrder(poNumber: number) {
        const purchaseOrder = await this.uow.getPurchaseOrderByPoNumber(poNumber.toString());
        if (!purchaseOrder) return;
        this.router.navigate(['/purchase-orders/' + purchaseOrder.id]);
    }

    async toggleShowCompleted() {
        this.showCompleted = !this.showCompleted;
        await this.getData();
    }

    async rowDoubleClick(e) {
        if (!e.data || !e.data.id) return;
        this.open(e.data);
    }

    selectionChange(e) {}

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    async open(selection: any) {
        const pickUp = (await this.uow.purchaseOrderPickUps.byId(selection.id, 'lines.purchaseOrderLine.purchaseOrder')) as PurchaseOrderPickUp;
        const modalRef = this.modalService.show(VendorPickupDialogComponent, {
            class: 'modal-lg',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                pickUp: pickUp,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            this.appInfo.pleaseWaitShow();
            await this.getData();
            modalRef.hide();
            this.appInfo.pleaseWaitHide();
        });
    }

    async delete(selection: any[]) {
        if (selection.some((p) => p.completed)) return;

        const success = await confirm(`Are you sure you want to DELETE this pickup?`, `${this.appInfo.settings.company}`);
        if (!success) return;
        this.appInfo.pleaseWaitShow();
        const ids = selection.map((x) => x.id);
        let pickups = (await this.uow.purchaseOrderPickUps.byIds(ids, 'lines')) as PurchaseOrderPickUp[];
        const date = new Date();
        pickups.forEach((pickup) => {
            pickup.deleted = date;
            pickup.deletedBy = this.auth.currentUser.userName;
            pickup.lines
                .filter((line) => !line.deleted)
                .forEach((line) => {
                    line.deleted = date;
                    line.deletedBy = this.auth.currentUser.userName;
                });
        });
        await this.uow.commit();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async complete(selection: any[]) {
        if (selection.some((p) => p.completed)) return;

        const success = await confirm(`Are you sure you want to COMPLETE this pickup?`, `${this.appInfo.settings.company}`);
        if (!success) return;
        this.appInfo.pleaseWaitShow();
        let pickups = (await this.uow.purchaseOrderPickUps.byIds(selection.map((x) => x.id))) as PurchaseOrderPickUp[];

        pickups.forEach((pickup) => {
            pickup.completed = new Date();
            pickup.completedBy = this.auth.currentUser.userName;
        });
        await this.uow.commit();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }
}
